import React, { useState, useEffect, useRef } from "react";
import TopBar from "../../components/TopBar/TopBar";
import { MainBodyStyle } from "../../styles/MainBodyStyles";
import Footer from "../../components/footer/Footer";
import { HeadingStyle } from "../../styles/HeadingStyles";
import { TextErrorStyle } from "../../styles/ErrorStyles";
import { toast } from "react-toastify";
import { SponsorValidationSchema } from "../../validations/SponsorValidation";
import { SponsorPageStyle } from "./Configuration.style";
import api from "../../api/configAxios";
import { useSelector } from "react-redux";
import Controller from "../../common/controller";
import { useLocation, useNavigate } from "react-router-dom";
import DurationSelector from "../../components/sponsors/DurationSelector";
import {
  getCurrentUTCTimeWithMicroseconds,
  toUTCWithMicroseconds,
} from "../../common/ConvertTime";
import ROUTE from "../../common/Routes";
import { mode } from "crypto-js";
import { getSlotUsageFromAccountList, isSlotTaken } from "../../Utils/sponsorSlots";



const UpdateSponsorPage = () => {
  const location = useLocation();
  const sponsor = location.state?.item;
  toast.error(sponsor);
  console.log("sponsor", sponsor);

  const fileInputRef = useRef(null);
  const { access_token } = useSelector((state) => state.userKeyRed);
  const today = new Date().toISOString().split("T")[0];
  const navigate = useNavigate();
  const [sponsorName, setSponsorName] = useState(sponsor?.name || "");
  const [sponsorLogo, setSponsorLogo] = useState();
  const [startDay, setStartDay] = useState("");
  const [endDay, setEndDay] = useState("");
  const [btnDisable, setBtnDisable] = useState(false);
  const [errors, setErrors] = useState();
  const [slotdata, setSlotData] = useState([]);
  const [isWeeklyEmail, setIsWeeklyEmail] = useState(false);
  const [logoSlot, setLogoSlot] = useState();
  const [isNotificationsAvailable, setIsNotificationsAvailable] =
    useState(true);

  const [durationList, setDurationList] = useState([30, 90, 180, 365]);
  const [isLockScreenWidget, setIsLockScreenWidget] = useState(false);
  const [lockScreenWidgetDuration, setLockScreenWidgetDuration] = useState("");
  const [lockScreenWidgetStart, setLockScreenWidgetStart] = useState("");
  const [lockScreenWidgetEnd, setLockScreenWidgetEnd] = useState("");

  const [isHomeScreenWidget, setIsHomeScreenWidget] = useState(false);
  const [homeScreenWidgetDuration, setHomeScreenWidgetDuration] = useState("");
  const [homeScreenWidgetStart, setHomeScreenWidgetStart] = useState("");
  const [homeScreenWidgetEnd, setHomeScreenWidgetEnd] = useState("");

  const [isAppSplashScreen, setIsAppSplashScreen] = useState(false);
  const [appSplashDuration, setAppSplashDuration] = useState("");
  const [appSplashStart, setAppSplashStart] = useState("");
  const [appSplashEnd, setAppSplashEnd] = useState("");

  const [isAppScrollBanner, setIsAppScrollBanner] = useState(false);
  const [appScrollBannerDuration, setAppScrollBannerDuration] = useState("");
  const [appScrollBannerStart, setAppScrollBannerStart] = useState("");
  const [appScrollBannerEnd, setAppScrollBannerEnd] = useState("");

  const [isMovementNotification, setIsMovementNotification] = useState(false);
  const [movementNotifDuration, setMovementNotifDuration] = useState("");
  const [movementNotifStart, setMovementNotifStart] = useState("");
  const [movementNotifEnd, setMovementNotifEnd] = useState("");

  const [isSafetyEmergencyNotification, setIsSafetyEmergencyNotification] =
    useState(false);
  const [safetyEmergencyNotifDuration, setSafetyEmergencyNotifDuration] =
    useState("");
  const [safetyEmergencyNotifStart, setSafetyEmergencyNotifStart] =
    useState("");
  const [safetyEmergencyNotifEnd, setSafetyEmergencyNotifEnd] = useState("");

  const [weeklyNotifDuration, setWeeklyNotifDuration] = useState("");
  const [weeklyNotifStart, setWeeklyNotifStart] = useState("");
  const [weeklyNotifEnd, setWeeklyNotifEnd] = useState("");

  const [isWeeklySystemReport, setIsWeeklySystemReport] = useState(false);
  const [weeklySystemReportDuration, setWeeklySystemReportDuration] =
    useState("");
  const [weeklySystemReportStart, setWeeklySystemReportStart] = useState("");
  const [weeklySystemReportEnd, setWeeklySystemReportEnd] = useState("");
  const [weeklySystemReportSlot, setWeeklySystemReportSlot] = useState("");

  const [
    isWeeklySystemReportNotifications,
    setIsWeeklySystemReportNotifications,
  ] = useState(false);
  const [weeklySystemReportNotifDuration, setWeeklySystemReportNotifDuration] =
    useState("");
  const [weeklySystemReportNotifStart, setWeeklySystemReportNotifStart] =
    useState("");
  const [weeklySystemReportNotifEnd, setWeeklySystemReportNotifEnd] =
    useState("");

  // Add state for placement IDs
  const [lockScreenWidgetId, setLockScreenWidgetId] = useState("");
  const [appSplashScreenId, setAppSplashScreenId] = useState("");
  const [appScrollBannerId, setAppScrollBannerId] = useState("");
  const [movementNotificationId, setMovementNotificationId] = useState("");
  const [safetyEmergencyNotificationId, setSafetyEmergencyNotificationId] =
    useState("");
  const [weeklyEmailId, setWeeklyEmailId] = useState("");
  const [weeklySystemReportId, setWeeklySystemReportId] = useState("");
  const [weeklySystemReportNotificationsId, setWeeklySystemReportNotificationsId] =
    useState("");
    const accountList = useSelector(state => state.sponsors?.accountList) || [];
    // Get all used slots from backend response
const usedSlots = getSlotUsageFromAccountList(accountList);
console.log("Used slots for validation:", usedSlots);



  useEffect(() => {
    if (sponsor && sponsor.sponsorshipPlacement && Array.isArray(sponsor.sponsorshipPlacement)) {
      setSponsorName(sponsor.name || "");
      setSponsorLogo(sponsor.logoImage || undefined);
      // Reset all toggles and values
      setIsLockScreenWidget(false);
      setLockScreenWidgetDuration("");
      setLockScreenWidgetStart("");
      setLockScreenWidgetEnd("");
      setIsHomeScreenWidget(false);
      setHomeScreenWidgetDuration("");
      setHomeScreenWidgetStart("");
      setHomeScreenWidgetEnd("");
      setIsAppSplashScreen(false);
      setAppSplashDuration("");
      setAppSplashStart("");
      setAppSplashEnd("");
      setIsAppScrollBanner(false);
      setAppScrollBannerDuration("");
      setAppScrollBannerStart("");
      setAppScrollBannerEnd("");
      setIsMovementNotification(false);
      setMovementNotifDuration("");
      setMovementNotifStart("");
      setMovementNotifEnd("");
      setIsSafetyEmergencyNotification(false);
      setSafetyEmergencyNotifDuration("");
      setSafetyEmergencyNotifStart("");
      setSafetyEmergencyNotifEnd("");
      setIsWeeklyEmail(false);
      setWeeklyNotifDuration("");
      setWeeklyNotifStart("");
      setWeeklyNotifEnd("");
      setIsWeeklySystemReport(false);
      setWeeklySystemReportDuration("");
      setWeeklySystemReportStart("");
      setWeeklySystemReportEnd("");
      setWeeklySystemReportSlot("");
      setIsWeeklySystemReportNotifications(false);
      setWeeklySystemReportNotifDuration("");
      setWeeklySystemReportNotifStart("");
      setWeeklySystemReportNotifEnd("");
      setLogoSlot("");
      // Populate fields for each sponsor placement
      sponsor.sponsorshipPlacement.forEach((placement) => {
        const start = placement.startDate ? placement.startDate.split("T")[0] : "";
        const end = placement.endDate ? placement.endDate.split("T")[0] : "";
        const duration = placement.duration || "";
        const slot = placement.slot || "";
        switch (placement.type) {
          case "Lock Screen Widget":
          case "LockScreenWidget":
          case "Widget":
            setIsLockScreenWidget(true);
            setLockScreenWidgetDuration(duration);
            setLockScreenWidgetStart(start);
            setLockScreenWidgetEnd(end);
            setLockScreenWidgetId(placement.sponsorPlacementId || "");
            break;
          case "Home Screen Widget":
          case "HomeScreenWidget":
            setIsHomeScreenWidget(true);
            setHomeScreenWidgetDuration(duration);
            setHomeScreenWidgetStart(start);
            setHomeScreenWidgetEnd(end);
            break;
          case "App Splash Screen":
          case "AppSplashScreen":
          case "Splash":
            setIsAppSplashScreen(true);
            setAppSplashDuration(duration);
            setAppSplashStart(start);
            setAppSplashEnd(end);
            setAppSplashScreenId(placement.sponsorPlacementId || "");
            break;
          case "App Scroll Banner":
          case "AppScrollBanner":
          case "App":
            setIsAppScrollBanner(true);
            setAppScrollBannerDuration(duration);
            setAppScrollBannerStart(start);
            setAppScrollBannerEnd(end);
            setAppScrollBannerId(placement.sponsorPlacementId || "");
            break;
          case "Movement Notifications":
          case "MovementNotification":
          case "Movement":
            setIsMovementNotification(true);
            setMovementNotifDuration(duration);
            setMovementNotifStart(start);
            setMovementNotifEnd(end);
            setMovementNotificationId(placement.sponsorPlacementId || "");
            break;
          case "Safety Emergency Notifications":
          case "SafetyEmergencyNotification":
          case "SafetyEmergency":
            setIsSafetyEmergencyNotification(true);
            setSafetyEmergencyNotifDuration(duration);
            setSafetyEmergencyNotifStart(start);
            setSafetyEmergencyNotifEnd(end);
            setSafetyEmergencyNotificationId(placement.sponsorPlacementId || "");
            break;
          case "Weekly Report Email":
          case "WeeklyEmail":
          case "WeeklyReportEmail":
            setIsWeeklyEmail(true);
            setWeeklyNotifDuration(duration);
            setWeeklyNotifStart(start);
            setWeeklyNotifEnd(end);
            setLogoSlot(slot);
            setWeeklyEmailId(placement.sponsorPlacementId || "");
            break;
          case "Weekly System Report Notifications":
          case "WeeklySystemReportNotifications":
          case "WeeklySystemNotification":
            setIsWeeklySystemReportNotifications(true);
            setWeeklySystemReportNotifDuration(duration);
            setWeeklySystemReportNotifStart(start);
            setWeeklySystemReportNotifEnd(end);
            setWeeklySystemReportNotificationsId(placement.sponsorPlacementId || "");
            break;
          case "Weekly System Report":
          case "WeeklySystemReport":
            setIsWeeklySystemReport(true);
            setWeeklySystemReportDuration(duration);
            setWeeklySystemReportStart(start);
            setWeeklySystemReportEnd(end);
            setWeeklySystemReportSlot(slot);
            setWeeklySystemReportId(placement.sponsorPlacementId || "");
            break;
          default:
            break;
        }
      });
    }
  }, [sponsor]);

  const Errors = (err) => {
    const element = err[0];

    const [code, message] = element.split(":");
    switch (code) {
      case "0":
        setErrors(message);
        break;
      case "1":
        setErrors(message);
        break;
      case "2":
        setErrors(message);
        break;
      case "3":
        setErrors(message);
        break;
      case "4":
        setErrors(message);
        break;
      case "5":
        setErrors(message);
        break;
      case "6":
        setErrors(message);
        break;
      case "7":
        setErrors(message);
        break;
      case "8":
        setErrors(message);
        break;
      case "9":
        setErrors(message);
        break;
      case "10":
        setErrors(message);
        break;
      case "11":
        setErrors(message);
        break;
      case "12":
        setErrors(message);
        break;
      default:
        break;
    }
  };

  const resetSponsorForm = () => {
    setSponsorName("");
    setSponsorLogo(undefined);
    setStartDay("");
    setEndDay("");
    setErrors("");
    setIsLockScreenWidget(false);
    setIsHomeScreenWidget(false);
    setIsAppSplashScreen(false);
    setIsAppScrollBanner(false);
    setIsMovementNotification(false);
    setIsSafetyEmergencyNotification(false);
    setIsWeeklyEmail(false);
    setIsWeeklySystemReport(false);
    setIsWeeklySystemReportNotifications(false);

    setLogoSlot("");
    setLockScreenWidgetDuration("");
    setLockScreenWidgetStart("");
    setLockScreenWidgetEnd("");
    setHomeScreenWidgetDuration("");
    setHomeScreenWidgetStart("");
    setHomeScreenWidgetEnd("");
    setAppSplashDuration("");
    setAppSplashStart("");
    setAppSplashEnd("");
    setAppScrollBannerDuration("");
    setAppScrollBannerStart("");
    setAppScrollBannerEnd("");
    setMovementNotifDuration("");
    setMovementNotifStart("");
    setMovementNotifEnd("");
    setSafetyEmergencyNotifDuration("");
    setSafetyEmergencyNotifStart("");
    setSafetyEmergencyNotifEnd("");
    setWeeklyNotifDuration("");
    setWeeklyNotifStart("");
    setWeeklyNotifEnd("");
    setWeeklySystemReportDuration("");
    setWeeklySystemReportStart("");
    setWeeklySystemReportEnd("");
    setWeeklySystemReportSlot("");
    setWeeklySystemReportNotifDuration("");
    setWeeklySystemReportNotifStart("");
    setWeeklySystemReportNotifEnd("");
    setIsNotificationsAvailable(true);

    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
    navigate(ROUTE.Analytics);
  };
  const updateSponsor = async (val) => {
    try {
      const formData = new FormData();
  
      formData.append("SponsorId", sponsor.sponsorId);
      formData.append("Name", val.Name);
  
      if (val.LogoImage instanceof File) {
        formData.append("LogoImage", val.LogoImage);
      }

      console.log("SponsorPlacementRequests payload:");
      val.SponsorPlacementRequests.forEach((p, i) => {
        console.log(
          `[${i}] type: ${p.sponsorPlacementType}, isActive: ${p.isActive}, isEnabled: ${p.isEnabled}, SponsorPlacementId: ${p.SponsorPlacementId}, duration: ${p.duration}, startDate: ${p.startDate}, endDate: ${p.endDate}`
        );
      });
  
      val.SponsorPlacementRequests.forEach((p, i) => {
        formData.append(`SponsorPlacementRequests[${i}].SponsorPlacementId`, p.SponsorPlacementId || "");
        formData.append(`SponsorPlacementRequests[${i}].StartDate`, p.startDate);
        formData.append(`SponsorPlacementRequests[${i}].EndDate`, p.endDate);
        formData.append(`SponsorPlacementRequests[${i}].IsActive`, p.isActive);
        formData.append(`SponsorPlacementRequests[${i}].IsEnabled`, p.isEnabled);
        formData.append(
          `SponsorPlacementRequests[${i}].SponsorPlacementType`,
          p.sponsorPlacementType
        );
        formData.append(
          `SponsorPlacementRequests[${i}].WeeklyEmailSlot`,
          (p.weeklyEmailSlot ?? 0).toString()
        );
        formData.append(`SponsorPlacementRequests[${i}].Slot`, p.Slot || "");
        formData.append(`SponsorPlacementRequests[${i}].Duration`, p.duration.toString());
      });
  
      // LOG the entire formData for debug
      for (let pair of formData.entries()) {
        console.log(`[formData] ${pair[0]}:`, pair[1]);
      }
  
      var response = await api.put(
        `${Controller.Sponsor}/UpdateSponsor`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: "Bearer " + access_token,
          },
        }
      );
  
      toast("Sponsor Updated successfully");
      resetSponsorForm();
    } catch (error) {
      console.error("Error updating sponsor:", error);
      if (error.response && error.response.status == 401) {
        toast.error("Token has expired.", {
          bodyClassName: "notification-div-error",
          progressClassName: "progress-bar-error",
        });
      } else {
        toast.error("Error has Ocurred.Try Again", {
          bodyClassName: "notification-div-error",
          progressClassName: "progress-bar-error",
        });
      }
    }
    setBtnDisable(false);
  };
  

  const buildSponsorPlacementRequests = () => {
    // Helper to build one placement request (always sends if exists or enabled)
    function build({
      enabled,
      id,
      start,
      end,
      duration,
      type,
      weeklyEmailSlot = "0",
      Slot = "0"
    }) {
      // If never enabled and no existing placement, skip
      if (!id && !enabled) return null;
  
      // If enabled, send actual values, else send empty/zero/null as per your backend needs
      return {
        SponsorPlacementId: id || "",
        startDate: start ? toUTCWithMicroseconds(start) : null,
        endDate: end ? toUTCWithMicroseconds(end) : null,
        isActive: !!enabled,
        isEnabled: !!enabled,
        duration: enabled ? duration || 0 : 0,
        sponsorPlacementType: type,
        weeklyEmailSlot: weeklyEmailSlot,
        dateCreated: getCurrentUTCTimeWithMicroseconds(),
        dateUpdated: getCurrentUTCTimeWithMicroseconds(),
        Slot: Slot,
      };
    }
  
    const placements = [
      build({
        enabled: isLockScreenWidget,
        id: lockScreenWidgetId,
        start: lockScreenWidgetStart,
        end: lockScreenWidgetEnd,
        duration: lockScreenWidgetDuration,
        type: "Widget",
      }),
      build({
        enabled: isAppSplashScreen,
        id: appSplashScreenId,
        start: appSplashStart,
        end: appSplashEnd,
        duration: appSplashDuration,
        type: "Splash",
      }),
      build({
        enabled: isAppScrollBanner,
        id: appScrollBannerId,
        start: appScrollBannerStart,
        end: appScrollBannerEnd,
        duration: appScrollBannerDuration,
        type: "App",
      }),
      build({
        enabled: isMovementNotification,
        id: movementNotificationId,
        start: movementNotifStart,
        end: movementNotifEnd,
        duration: movementNotifDuration,
        type: "Movement",
      }),
      build({
        enabled: isSafetyEmergencyNotification,
        id: safetyEmergencyNotificationId,
        start: safetyEmergencyNotifStart,
        end: safetyEmergencyNotifEnd,
        duration: safetyEmergencyNotifDuration,
        type: "SafetyEmergency",
      }),
      build({
        enabled: isWeeklyEmail,
        id: weeklyEmailId,
        start: weeklyNotifStart,
        end: weeklyNotifEnd,
        duration: weeklyNotifDuration,
        type: "WeeklyReportEmail",
        weeklyEmailSlot: logoSlot,
      }),
      build({
        enabled: isWeeklySystemReportNotifications,
        id: weeklySystemReportNotificationsId,
        start: weeklySystemReportNotifStart,
        end: weeklySystemReportNotifEnd,
        duration: weeklySystemReportNotifDuration,
        type: "WeeklySystemNotifications",
      }),
      build({
        enabled: isWeeklySystemReport,
        id: weeklySystemReportId,
        start: weeklySystemReportStart,
        end: weeklySystemReportEnd,
        duration: weeklySystemReportDuration,
        type: "WeeklySystemReport",
        weeklyEmailSlot: weeklySystemReportSlot,
      }),
    ];
  
    // Remove nulls
    const requests = placements.filter(Boolean);
  
    // Debug log
    console.log("SponsorPlacementRequests to send:", requests);
  
    return requests;
  };
  
  const validateForm = async () => {
    setErrors("");
    setBtnDisable(true);
    const formData = {
      mode:"update",
      Name: sponsorName,
      LogoImage: sponsorLogo ? sponsorLogo : undefined,
      SponsorPlacementRequests: buildSponsorPlacementRequests() || [],
    };
    console.log("Validate formData:", formData);
  
    await SponsorValidationSchema.validate(formData, {
      abortEarly: false,
    })
      .then((value) => {
        updateSponsor(value);
      })
      .catch((err) => {
        setBtnDisable(false);
        if (Array.isArray(err.errors) && err.errors.length > 0) {
          Errors(err.errors);
        } else if (err.message) {
          setErrors("Unexpected Error: " + err.message);
          console.error("Validation/UpdateSponsor Error", err);
        } else {
          setErrors("Unexpected error occurred, please try again.");
          console.error("Unknown error", err);
        }
      });
  };
  
  

  return (
    <SponsorPageStyle>
      <TopBar authorized={true} />

      <MainBodyStyle>
        <HeadingStyle>Sponsors Configurations</HeadingStyle>
        <div className="configurationCardWidth configurationCard">
          <table className="table-div">
            <tbody>
              <tr className="row-div">
                <td>
                  <div className="field-div"> Sponsor Name:</div>
                </td>
                <td>
                  <input
                    value={sponsorName}
                    onChange={(e) => setSponsorName(e.target.value)}
                    type="text"
                    id="sponsorName"
                    maxLength={30}
                    placeholder="Enter Sponsor Name"
                    className="form-control mt-1 input-field"
                  />
                </td>
              </tr>

              <tr className="row-div">
                <td>
                  <div className="field-div-logo">Sponsor Logo:</div>
                </td>
                <td>
                  <input
                    type="file"
                    accept=".png,.svg"
                    id="sponsorLogo"
                    className="form-control mt-1 input-field"
                    ref={fileInputRef}
                    onChange={(e) => {
                      const file = e.target.files && e.target.files[0];
                      if (file) {
                        const allowedTypes = ["image/png", "image/svg+xml"];
                        if (!allowedTypes.includes(file.type)) {
                          toast.error("File type must be png or svg.", {
                            bodyClassName: "notification-div-error",
                            progressClassName: "progress-bar-error",
                          });
                          e.target.value = "";
                          return;
                        }
                        if (file.size > 500 * 1024) {
                          toast.error("File cannot be greater than 500 KB.", {
                            bodyClassName: "notification-div-error",
                            progressClassName: "progress-bar-error",
                          });
                          e.target.value = "";
                          return;
                        }
                        setSponsorLogo(file);
                      }
                    }}
                  />
                  <div
                    style={{ fontSize: 11, color: "#888", textAlign: "end" }}
                  >
                    <span
                      title="Logo must be a square image"
                      style={{
                        marginRight: 5,
                        color: "#888",
                        cursor: "pointer",
                      }}
                    >
                      <i className="bi bi-info-circle" />
                    </span>
                    <div>Supported formats: SVG, PNG</div>
                    <div>Logos must be monochrome and have transparent backgrounds</div>
                  </div>
                </td>
              </tr>

              {/* -------------- Lock Screen Widget --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Home/Lock Screen Widget: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="LockScreenWidgetRadio"
                        id="isLockScreenWidgetTrue"
                        checked={isLockScreenWidget}
                        onChange={() => {
                          setIsLockScreenWidget(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isLockScreenWidgetTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="LockScreenWidgetRadio"
                        id="isLockScreenWidgetFalse"
                        checked={!isLockScreenWidget}
                        onChange={() => {
                          setIsLockScreenWidget(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isLockScreenWidgetFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isLockScreenWidget && (
                <DurationSelector
                  label="Lock Screen Widget"
                  duration={lockScreenWidgetDuration}
                  setDuration={setLockScreenWidgetDuration}
                  startDate={lockScreenWidgetStart}
                  setStartDate={setLockScreenWidgetStart}
                  endDate={lockScreenWidgetEnd}
                  setEndDate={setLockScreenWidgetEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}
              {/* -------------- Home Screen Widget --------------------- */}

              {/* -------------- App Splash Screen Widget --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>App Splash Screen: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="AppSplashScreenRadio"
                        id="isAppSplashScreenTrue"
                        checked={isAppSplashScreen}
                        onChange={() => {
                          setIsAppSplashScreen(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isAppSplashScreenTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="AppSplashScreenRadio"
                        id="isAppSplashScreenFalse"
                        checked={!isAppSplashScreen}
                        onChange={() => {
                          setIsAppSplashScreen(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isAppSplashScreenFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isAppSplashScreen && (
                <DurationSelector
                  label="App Splash Screen"
                  duration={appSplashDuration}
                  setDuration={setAppSplashDuration}
                  startDate={appSplashStart}
                  setStartDate={setAppSplashStart}
                  endDate={appSplashEnd}
                  setEndDate={setAppSplashEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}

              {/* -------------- App Scroll Banner --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>App Scroll Banner: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="AppScrollBannerRadio"
                        id="isAppScrollBannerTrue"
                        checked={isAppScrollBanner}
                        onChange={() => {
                          setIsAppScrollBanner(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isAppScrollBannerTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="AppScrollBannerRadio"
                        id="isAppScrollBannerFalse"
                        checked={!isAppScrollBanner}
                        onChange={() => {
                          setIsAppScrollBanner(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isAppScrollBannerFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isAppScrollBanner && (
                <DurationSelector
                  label="App Scroll Banner"
                  duration={appScrollBannerDuration}
                  setDuration={setAppScrollBannerDuration}
                  startDate={appScrollBannerStart}
                  setStartDate={setAppScrollBannerStart}
                  endDate={appScrollBannerEnd}
                  setEndDate={setAppScrollBannerEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}

              {/* -------------- Movement Notifications --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Movement Notifications: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="MovementNotificationRadio"
                        id="isMovementNotificationTrue"
                        checked={isMovementNotification}
                        disabled={!isNotificationsAvailable}
                        onChange={() => {
                          setIsMovementNotification(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isMovementNotificationTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="MovementNotificationRadio"
                        id="isMovementNotificationFalse"
                        checked={!isMovementNotification}
                        onChange={() => {
                          setIsMovementNotification(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isMovementNotificationFalse"
                      >
                        Disable
                      </label>
                    </div>
                    <div className="form-check">
                      {!isNotificationsAvailable && (
                        <span style={{ color: "red", fontSize: 9 }}>
                          Not available in the selected time slot
                        </span>
                      )}
                    </div>
                  </div>
                </td>
              </tr>
              {isMovementNotification && (
                <DurationSelector
                  label="Movement Notification"
                  duration={movementNotifDuration}
                  setDuration={setMovementNotifDuration}
                  startDate={movementNotifStart}
                  setStartDate={setMovementNotifStart}
                  endDate={movementNotifEnd}
                  setEndDate={setMovementNotifEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}
              {/* -------------- Safety Emergency Notifications --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Safety Emergency Notifications: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="SafetyEmergencyNotificationRadio"
                        id="isSafetyEmergencyNotificationTrue"
                        checked={isSafetyEmergencyNotification}
                        onChange={() => {
                          setIsSafetyEmergencyNotification(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isSafetyEmergencyNotificationTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="SafetyEmergencyNotificationRadio"
                        id="isSafetyEmergencyNotificationFalse"
                        checked={!isSafetyEmergencyNotification}
                        onChange={() => {
                          setIsSafetyEmergencyNotification(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isSafetyEmergencyNotificationFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isSafetyEmergencyNotification && (
                <DurationSelector
                  label="Safety Emergency Notifications"
                  duration={safetyEmergencyNotifDuration}
                  setDuration={setSafetyEmergencyNotifDuration}
                  startDate={safetyEmergencyNotifStart}
                  setStartDate={setSafetyEmergencyNotifStart}
                  endDate={safetyEmergencyNotifEnd}
                  setEndDate={setSafetyEmergencyNotifEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}

              {/* -------------- Weekly Report Email --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Weekly Report Email: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="weeklyEmailRadio"
                        id="isWeeklyEmailTrue"
                        checked={isWeeklyEmail}
                        onChange={() => {
                          setIsWeeklyEmail(true);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklyEmailTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="weeklyEmailRadio"
                        id="isWeeklyEmailFalse"
                        checked={!isWeeklyEmail}
                        onChange={() => {
                          setIsWeeklyEmail(false);
                        }}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklyEmailFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isWeeklyEmail && (
                <DurationSelector
                  label="Weekly Report Email"
                  duration={weeklyNotifDuration}
                  setDuration={setWeeklyNotifDuration}
                  startDate={weeklyNotifStart}
                  setStartDate={setWeeklyNotifStart}
                  endDate={weeklyNotifEnd}
                  setEndDate={setWeeklyNotifEnd}
                  durationOptions={durationList}
                  minDate={today}
                />
              )}
             {isWeeklyEmail && (
  <tr className="row-div">
    <td>
      <div className="field-div">Logo Slot:</div>
    </td>
    <td>
      <select
        className="form-control mt-1 input-field"
        value={logoSlot || ""}
        onChange={(e) => setLogoSlot(Number(e.target.value))}
      >
        <option value="" disabled>Select Slot</option>
        {[...Array(12)].map((_, i) => {
          const slot = i + 1;
          const slotUnavailable = isSlotTaken({
            usedSlots,
            slot,
            type: "WeeklyReportEmail",
            selectedStart: weeklyNotifStart || today,
            selectedEnd: weeklyNotifEnd || today,
            currentSponsorId: sponsor?.sponsorId,
          });
          if (slotUnavailable) {
            console.log(
              `Slot ${slot} is unavailable for WeeklyReportEmail for sponsor ${sponsor?.sponsorId}`
            );
          }
          return (
            <option key={slot} value={slot} disabled={slotUnavailable}>
              {slot} {slotUnavailable ? "(Unavailable)" : ""}
            </option>
          );
        })}
      </select>
    </td>
  </tr>
)}

              {/* -------------- Weekly Report Notifications --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Weekly System Report Notifications: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="WeeklySystemReportNotificationsRadio"
                        id="isWeeklySystemReportNotificationsTrue"
                        checked={isWeeklySystemReportNotifications}
                        onChange={() =>
                          setIsWeeklySystemReportNotifications(true)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklySystemReportNotificationsTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="WeeklySystemReportNotificationsRadio"
                        id="isWeeklySystemReportNotificationsFalse"
                        checked={!isWeeklySystemReportNotifications}
                        onChange={() =>
                          setIsWeeklySystemReportNotifications(false)
                        }
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklySystemReportNotificationsFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isWeeklySystemReportNotifications && (
                <>
                  <DurationSelector
                    label="Weekly System Report Notifications"
                    duration={weeklySystemReportNotifDuration}
                    setDuration={setWeeklySystemReportNotifDuration}
                    startDate={weeklySystemReportNotifStart}
                    setStartDate={setWeeklySystemReportNotifStart}
                    endDate={weeklySystemReportNotifEnd}
                    setEndDate={setWeeklySystemReportNotifEnd}
                    durationOptions={durationList}
                    minDate={today}
                  />
                </>
              )}
              {/* -------------- Weekly System Report --------------------- */}
              <tr className="row-div">
                <td className="field-div">
                  <h6>Weekly System Report: </h6>
                </td>
                <td>
                  <div className="radio-div2">
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="WeeklySystemReportRadio"
                        id="isWeeklySystemReportTrue"
                        checked={isWeeklySystemReport === true}
                        onChange={() => setIsWeeklySystemReport(true)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklySystemReportTrue"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="form-check">
                      <input
                        className="form-check-input"
                        type="radio"
                        name="WeeklySystemReportRadio"
                        id="isWeeklySystemReportFalse"
                        checked={isWeeklySystemReport === false}
                        onChange={() => setIsWeeklySystemReport(false)}
                      />
                      <label
                        className="form-check-label"
                        htmlFor="isWeeklySystemReportFalse"
                      >
                        Disable
                      </label>
                    </div>
                  </div>
                </td>
              </tr>
              {isWeeklySystemReport && (
                <>
                  <DurationSelector
                    label="Weekly System Report"
                    duration={weeklySystemReportDuration}
                    setDuration={setWeeklySystemReportDuration}
                    startDate={weeklySystemReportStart}
                    setStartDate={setWeeklySystemReportStart}
                    endDate={weeklySystemReportEnd}
                    setEndDate={setWeeklySystemReportEnd}
                    durationOptions={durationList}
                    minDate={today}
                  />
                  <tr className="row-div">
                    <td>
                      <div className="field-div">Weekly System Report Slot:</div>
                    </td>
                    <td>
                      <select
                        className="form-control mt-1 input-field"
                        value={weeklySystemReportSlot || ""}
                        onChange={(e) => setWeeklySystemReportSlot(Number(e.target.value))}
                      >
                        <option value="" disabled>Select Slot</option>
                        {[...Array(12)].map((_, i) => {
                          const slot = i + 1;
                          const slotUnavailable = isSlotTaken({
                            usedSlots,
                            slot,
                            type: "WeeklySystemReport",
                            selectedStart: weeklySystemReportStart || today,
                            selectedEnd: weeklySystemReportEnd || today,
                            currentSponsorId: sponsor?.sponsorId,
                          });
                          return (
                            <option key={slot} value={slot} disabled={slotUnavailable}>
                              {slot} {slotUnavailable ? "(Unavailable)" : ""}
                            </option>
                          );
                        })}
                      </select>
                    </td>
                  </tr>
                </>
              )}
            </tbody>
          </table>
          <button
            type="submit"
            className={"btn form-button"}
            disabled={btnDisable}
            onClick={validateForm}
          >
            Update Sponsor
          </button>
          {errors && <TextErrorStyle>{errors}</TextErrorStyle>}
        </div>
      </MainBodyStyle>
      <Footer style="footer" />
    </SponsorPageStyle>
  );
};

export default UpdateSponsorPage;
